import { useEffect, useRef, useState } from "react";
import { Typography, Box, useTheme } from "@mui/material";

import { DropdownV1, SearchBar } from "components";
import LedgerDetails from "./LedgerDetails";
import NoCustomer from "./components/NoCustomer";

import { getCall_v2, postCall_v2 } from "services";
import CUSTOMER_LEDGER from "./constants";
import { JOMS_API_BASE_V1_URL, error } from "constants";
import { useToaster } from "hooks";

const SearchResultBox = ({ companyName, gstin }) => {
  const theme = useTheme();

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      gap={1}
      minWidth={300}
    >
      <Typography sx={{ fontSize: 14, color: theme.palette.grey["A300"] }}>
        {companyName}
      </Typography>
      <Typography variant="body2" sx={{ color: theme.palette.grey["1000"] }}>
        {gstin}
      </Typography>
    </Box>
  );
};

const CustomerLedger = () => {
  const [searchDetails, setSearchDetails] = useState();
  const [ledgerType, setLedgerType] = useState(CUSTOMER_LEDGER.ledgerType.JODL);
  const [isNodal, setIsNodal] = useState(true);
  const filterRef = useRef();
  const triggerToaster = useToaster();
  const theme = useTheme();

  /**
   * @param {*} searchInput
   * @returns a list of data matching with search input
   */
  const getSearchResponse = async (searchInput) => {
    try {
      const res = await getCall_v2(
        `/joms/api/external/v1/customer-details-by-reference/${searchInput}`,
      );
      return res?.data?.data;
    } catch (err) {
      console.error(`Error in fetching search results, ${err}`);
    }
  };

  const fetchCustomerType = async (gstIn) => {
    try {
      const res = await postCall_v2(
        `${JOMS_API_BASE_V1_URL}/v1/customer-by-gst`,
        { gstIn },
      );
      if (res) {
        setIsNodal(res?.data?.data.nodal);
      }
    } catch {
      triggerToaster(`Fail to fetch customer type`, error);
    }
  };

  useEffect(() => {
    if (searchDetails?.gstin) {
      void fetchCustomerType(searchDetails?.gstin);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDetails]);

  const handleLedgerType = (e) => {
    setLedgerType(e?.target?.value);
  };

  /**
   * @param {*} data
   * @description save search results in state
   */
  const passValue = (data) => setSearchDetails(data);

  const ledgerTypeValue = Object.keys(CUSTOMER_LEDGER.ledgerType).find(
    (key) => CUSTOMER_LEDGER.ledgerType[key] === ledgerType,
  );

  return (
    <Box>
      <Box
        sx={{
          border: `1px solid ${theme.palette.grey["400"]}`,
          padding: 4,
          borderRadius: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            mb={2}
            sx={{ color: theme.palette.grey["A300"], fontSize: 14 }}
          >
            Select customer
          </Typography>
          <SearchBar
            style={{ width: 310 }}
            resolver={getSearchResponse}
            displayAttribute="companyName"
            onItemSelect={passValue}
            renderItem={SearchResultBox}
            placeholder={"Search here"}
            ref={filterRef}
            customListStyle={{
              border: 0,
              boxShadow: `0 0 12px 6px ${theme.palette.grey["400"]}`,
            }}
          />
        </Box>
        {!isNodal && (
          <Box>
            <DropdownV1
              itemList={Object.values(CUSTOMER_LEDGER?.ledgerType)}
              value={ledgerType}
              listType="array"
              onChange={handleLedgerType}
              placeholder={"Ledger Type"}
              sx={{ width: 240 }}
            />
          </Box>
        )}
      </Box>
      {searchDetails ? (
        <LedgerDetails
          selectedCustomer={searchDetails}
          ledgerType={isNodal ? "JOPL" : ledgerTypeValue}
          isNodal={isNodal}
        />
      ) : (
        <NoCustomer />
      )}
    </Box>
  );
};

export default CustomerLedger;
